import { useContext } from 'react'
import { ConnectParamsContext } from './paramsContext'

export const useConnectParams = () => {
  return useContext(ConnectParamsContext)
}
